import React, {useEffect, useState} from 'react';

import {Permissions} from 'auth/PermissionConstants';
import DocumentActions, {LATEST_DOCUMENT_VERSION} from 'notebook/documents/DocumentActions';
import {FromServerDocumentVersion} from 'notebook/documents/DocumentConstants';
import DocumentStore from 'notebook/documents/DocumentStore';
import {ItemVersionState} from 'notebook/store/VersionedItemSubstore';
import VersionHistoryPanel from 'notebook/version-history/VersionHistoryPanel';
import {Version} from 'notebook/version-history/VersionHistoryTypes';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

interface Props {
  id: string;
  title: string;
}

export function DocumentHistoryPanel({id, title}: Props): JSX.Element {
  const [versionState, setVersionState] = useState<ItemVersionState<FromServerDocumentVersion> | null>(null);
  const [permissions, setPermissions] = useState<Permissions | null>(null);

  const openVersion = (versionId: number): void => {
    DocumentActions.loadVersion(id, versionId);
  };

  useEffect(() => {
    const callback = (): void => {
      setVersionState(DocumentStore.getVersionState(id));
      setPermissions(DocumentStore.getDocumentPermissions(id));
    };

    const openDocument = async (): Promise<void> => {
      const document = DocumentStore.getDocument(id);
      if (!document || document.isStale) {
        await DocumentActions.open(id, {documentVersionId: LATEST_DOCUMENT_VERSION});
      }
      DocumentActions.fetchVersions(id);

      DocumentStore.addChangeListener(callback);
    };
    openDocument();
    return () => {
      DocumentStore.removeChangeListener(callback);
    };
  }, [id]);

  // TODO(BNCH-99701): Add resetToVersion()

  // TODO(BNCH-99703): Add cloneFromVersion()

  if (versionState == null || permissions == null || versionState.versions.length === 0) {
    return <CenteredHorizontalThrobber />;
  }
  const openVersionId = versionState.openVersionId === false ? undefined : versionState.openVersionId;

  const versions: Array<Version> = versionState.versions.slice().reverse();
  return (
    <VersionHistoryPanel
      versions={versions}
      openVersionId={openVersionId}
      navigateAndSetOpenVersionId={openVersion}
      enableResetToVersion={false}
      resetToVersion={() => {}}
      enableDuplicateFromVersion={false}
      duplicateFromVersion={() => {}}
      unsaved={versionState.unsaved}
      headerTitle={title}
    />
  );
}
